import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ScaleLoadingSpinner } from '@cloudorder/ui';

import styles from './RouteStatus.module.css';

/** Shown while a lazy route chunk is in flight. */
export function RouteLoading({ label }: { readonly label?: string }): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={styles.centred} role="status" aria-live="polite">
      <ScaleLoadingSpinner size="large" text={label ?? t('state.loading')} />
    </div>
  );
}
